// src/components/steps/Confirm.jsx
import React, { useEffect } from "react";
import HorizontalTimeline from "../HorizontalTimeline";
import { useNavigate } from "react-router-dom";
import { ScaleLoader } from "react-spinners";
import delay from "delay";
import Space from "../Space";
import config from "../../config/properties.json";
import OrdersApi from "../../api/bff/src/api/OrdersApi";
import ApiClient from "../../api/bff/src/ApiClient";
import ConfirmedBasketsApi from "../../api/bff/src/api/ConfirmedBasketsApi";
import { default as content } from '../../content/en';

export default function OrderProcessing({
  next,
  prev,
  userEmail,
  userSimType,
  userPlan,
  planPrice,
  customerSelections,
  setCustomerSelections,
  basketRefId,
  setOrderRef
}) {

  const apiClient = new ApiClient(config.apiBaseUrl);
  const [processing, setProcessing] = React.useState(true);

  const searchParams = new URLSearchParams(window.location.search);
  const paymentStatus = searchParams.get("paymentStatus");

  const ordersApi = new OrdersApi(apiClient);
  const confirmedBasketsApi = new ConfirmedBasketsApi(apiClient);

  const storedCustomerSelections = JSON.parse(localStorage.getItem("customerSelections"));

  const navigate = useNavigate();

  const pollOrderStatus = async () => {
    const startTime = Date.now()
    let orderFailedOrSuccess = false;

    while (!orderFailedOrSuccess && (Date.now() - startTime) < config.orderPollingTimeout) {
      await delay(config.orderPollingInterval); // 5 seconds delay to let the animation play out a bit (first time) and then so as not to spam the API
      try {
        const order = await ordersApi.ordersGet(basketRefId);

        if (order?.status === "successful" || order?.status === "account.create.successful") {
          orderFailedOrSuccess = true;
          //setProcessing(false);
          await delay(3000); // Additional delay before next step
          console.log("Successful order so Navigating to confirmation step with orderRef: ", order.orderRefId);
          setOrderRef(order.orderRefId);

          //successful order, display confirmation screen and clear local storage
          localStorage.removeItem("confirmedBasketId");
          localStorage.removeItem("appliedDiscount");

          if (storedCustomerSelections !== null) {
            setCustomerSelections({
              ...storedCustomerSelections,
              ["Payment Details"]: {
                stepDescription: content.orderProcessing.paymentConfirmed
              },
            });
            localStorage.removeItem("customerSelections");
          }

          navigate("/confirmation", { replace: true }); // Navigate to confirmation step
        } else if (order?.status === "failed" || order?.status === "cancelled") {
          orderFailedOrSuccess = true;
          console.log("Failed or cancelled order so Navigating to error step");
          navigate("/error");
        }



      } catch (error) {
        console.log("Error fetching order: ", error);
      }
    }
    //if we hit this point and still have not had the order completed, show error
    if (!orderFailedOrSuccess) {
      console.log("Order polling timed out, navigating to error step");
      navigate("/error");
    }

  }

  useEffect(() => {

    pollOrderStatus();

  }, []);

  return (
    <>
      <div className="scaleloader-processing">
        <ScaleLoader
          color="#f36d13"
          size={200}
          loading={processing}
          cssOverride={{
            justifySelf: "center",
            display: "block",
          }} />
      </div>
      <Space height={48} />

      <div className="card">
        <div className="step-header">
          <h2>{content.orderProcessing.h2}</h2>
        </div>
        <div style={{ padding: 24 }}>
          <br />
          <p>{content.orderProcessing.basketRef} {basketRefId}</p>
          <br />
          <p>
            {content.orderProcessing.processingMessage}
          </p>
          <br />
        </div>
      </div>
    </>
  );
}
